import * as React from "react";
const LocationIconeMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.073}
      d="M4.096 5.64a1.61 1.61 0 1 0 3.219 0 1.61 1.61 0 0 0-3.219 0Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.073}
      d="M8.74 8.674 6.464 10.95a1.073 1.073 0 0 1-1.517 0L2.671 8.674a4.291 4.291 0 1 1 6.069 0Z"
    />
  </svg>
);
export default LocationIconeMoblie;
